import type { DisciplineRow } from '../../lib/aggregates.ts';

interface DisciplineBreakdownProps {
  rows: readonly DisciplineRow[];
}

export function DisciplineBreakdown({ rows }: DisciplineBreakdownProps) {
  const visible = rows.filter((r) => r.pageCount > 0);

  return (
    <div style={cardStyle}>
      <div style={labelStyle}>DISCIPLINE BREAKDOWN</div>
      {visible.length === 0 ? (
        <div style={{ color: '#525870', fontSize: 13, marginTop: 12 }}>
          No graded pages yet.
        </div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, marginTop: 12 }}>
          <thead>
            <tr style={headRowStyle}>
              <th style={{ ...thStyle, textAlign: 'left' }}>Category</th>
              <th style={thStyle}>Pages</th>
              <th style={{ ...thStyle, color: '#00E87A' }}>Exact %</th>
              <th style={{ ...thStyle, color: '#C49BFF' }}>Sub-mismatch %</th>
              <th style={{ ...thStyle, color: '#FF6B7A' }}>Disc-mismatch %</th>
            </tr>
          </thead>
          <tbody>
            {visible.map((row) => (
              <tr key={row.value} style={{ borderBottom: '1px solid rgba(255,255,255,0.04)' }}>
                <td style={{ padding: '10px 8px', color: '#F0F2FF' }}>
                  {row.label}
                  <span style={groupTagStyle(row.group)}>{row.group}</span>
                </td>
                <td style={tdStyle}>{row.pageCount}</td>
                <td style={{ ...tdStyle, color: row.exactPct > 0 ? '#00E87A' : '#525870' }}>
                  {row.exactPct.toFixed(1)}
                </td>
                <td style={{ ...tdStyle, color: row.subMismatchPct > 0 ? '#C49BFF' : '#525870' }}>
                  {row.subMismatchPct.toFixed(1)}
                </td>
                <td style={{ ...tdStyle, color: row.disciplineMismatchPct > 0 ? '#FF6B7A' : '#525870' }}>
                  {row.disciplineMismatchPct.toFixed(1)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

function groupTagStyle(group: 'discipline' | 'special' | 'other'): React.CSSProperties {
  const palette: Record<typeof group, string> = {
    discipline: '#00E87A',
    special: '#C49BFF',
    other: '#525870',
  };
  return {
    marginLeft: 8,
    fontSize: 9,
    fontFamily: "'JetBrains Mono', monospace",
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: palette[group],
    padding: '2px 6px',
    border: `1px solid ${palette[group]}`,
    borderRadius: 4,
    opacity: 0.7,
  };
}

const cardStyle: React.CSSProperties = {
  padding: 18,
  background: '#0D0F1C',
  border: '1px solid rgba(255,255,255,0.08)',
  borderRadius: 10,
};

const labelStyle: React.CSSProperties = {
  color: '#525870',
  fontSize: 10,
  fontFamily: "'JetBrains Mono', monospace",
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
};

const headRowStyle: React.CSSProperties = {
  textAlign: 'right',
  color: '#525870',
  fontFamily: "'JetBrains Mono', monospace",
  fontSize: 10,
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
};

const thStyle: React.CSSProperties = {
  padding: '8px',
  borderBottom: '1px solid rgba(255,255,255,0.06)',
  textAlign: 'right',
  fontWeight: 600,
};

const tdStyle: React.CSSProperties = {
  padding: '10px 8px',
  textAlign: 'right',
  fontFamily: "'JetBrains Mono', monospace",
};
